import { logError } from '../../Shared/Logger';
import { setupDisclosureButtons } from './DisclosureButtons';
import { setupSmartMenusSync } from './SmartMenusSync';
import { setupFocusManagement } from './FocusManagement';
import { setupArrowKeyNavigation } from './KeyboardNavigation';

const LOG_CONTEXT = 'SmartMenuAccessibility';

let initialized = false;

/**
 * Initialize SmartMenu accessibility enhancements.
 *
 * Must be called AFTER SmartMenus has been initialized so we can read
 * the ARIA attributes it places on links and migrate them to buttons.
 *
 * @param selectors - Menu container selectors matching those passed to smartmenus()
 */
export const initSmartMenuAccessibility = (selectors: readonly string[]): void => {
    if (initialized) {
        logError(LOG_CONTEXT, 'Already initialized, skipping');
        return;
    }
    initialized = true;

    try {
        // 1. Inject disclosure buttons, migrate ARIA attributes, remove incorrect roles
        setupDisclosureButtons(selectors);

        // 2. Override SmartMenus link behavior, bind keyboard/click handlers, sync events
        setupSmartMenusSync(selectors);

        // 3. Set up focus management (close menus when focus leaves)
        setupFocusManagement(selectors);

        // 4. Arrow key, Home, End, and Escape navigation
        setupArrowKeyNavigation(selectors);
    } catch (error) {
        logError(LOG_CONTEXT, 'Initialization failed:', error);
    }
};
